import TransactionIcon from '@/icons/transaction-icon';

export default function GiftCardTransaction(props: {
  onNavigate: (path: string) => void;
}) {
  return (
    <div
      className="click-effect mx-auto flex min-h-[400px] w-full cursor-pointer flex-col items-center justify-center rounded-lg border border-silver"
      onClick={() => props.onNavigate('/gift-card/transactions')}
    >
      <div className="flex items-center justify-center h-32">
        <TransactionIcon style={{ width: 88, height: 88 }} />
      </div>
      <div className="text-2xl font-bold">Gift card transaction</div>
    </div>
  );
}
